import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import './jquery.redirectForm';

export default (): void => {
      $('body').redirectForm();
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/RedirectForm.js